














































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { getGlobal, OpenTicketGlobal } from '@/utils/windowOpenTicket';

interface WaasStats {
    connectionDurationMs: number;
    customerId: string | null;
    currentPhase: string | null;
    lastStatus: string | null;
    msSinceStart: number;
    openAt: Date | null;
    queueId: string | null;
    spot: bigint;
    startAt: Date | null;
    token: string | null;
    tokenStorage: string | null;
}

@Component
export default class DebugWaas extends Vue {
    stats: WaasStats = {
        connectionDurationMs: 0,
        customerId: null,
        currentPhase: null,
        lastStatus: null,
        msSinceStart: 0,
        openAt: null,
        queueId: null,
        spot: 0n,
        startAt: null,
        token: null,
        tokenStorage: null,
    };

    durationValuesInterval = 0;
    deregisterStateChangeHandler: () => void = () => {
        /* No-op */
    };

    previousErrors: string[] = [];

    mounted() {
        const OT: OpenTicketGlobal = getGlobal();
        if (OT.Waas) {
            this.deregisterStateChangeHandler = OT.Waas.on(
                'state-change',
                (error?: string) => {
                    if (error) {
                        this.previousErrors.unshift(error);
                    }

                    this.updateStats();
                }
            );
        }

        // Update duration based values
        window.clearInterval(this.durationValuesInterval);
        this.durationValuesInterval = window.setInterval(() => {
            this.stats.msSinceStart = this.stats.startAt
                ? Date.now() - this.stats.startAt.getTime()
                : -1;
        });

        this.updateStats();
    }

    beforeUnmount() {
        this.deregisterStateChangeHandler();

        window.clearInterval(this.durationValuesInterval);
    }

    private updateStats() {
        const OT: OpenTicketGlobal = getGlobal();
        this.stats.connectionDurationMs = OT.Waas?.connectionOpenAt
            ? OT.Waas.connectionOpenAt.getTime() -
              OT.Waas.connectionStartAt.getTime()
            : -1;
        this.stats.customerId = OT.Waas?.customerId || null;
        this.stats.currentPhase = OT.Waas?.currentPhase || null;
        this.stats.lastStatus = OT.Waas?.lastStatus || null;
        // msSinceStart abd msSinceStartLabel are handled separately;
        this.stats.openAt = OT.Waas?.connectionOpenAt || null;
        this.stats.queueId = OT.Waas?.queueId || null;
        this.stats.spot = OT.Waas?.spot || -1n;
        this.stats.startAt = OT.Waas?.connectionStartAt || null;
        this.stats.token = OT.Waas?.token || null;

        this.refreshStorage();
    }

    refreshStorage(): void {
        const OT: OpenTicketGlobal = getGlobal();

        if (!OT.Waas?.storage.test()) {
            this.stats.tokenStorage = 'Storage unavailable';
        } else if (!OT.Waas?.queueId) {
            this.stats.tokenStorage = null;
        } else {
            this.stats.tokenStorage =
                OT.Waas.storage.get(OT.Waas.queueId) || '- Empty -';
        }
    }

    removeStorage(): void {
        const OT: OpenTicketGlobal = getGlobal();

        if (OT.Waas?.queueId) {
            OT.Waas.storage.remove(OT.Waas.queueId);
        }

        this.refreshStorage();
    }

    get msSinceStartLabel(): string {
        if (!this.stats.msSinceStart) {
            return '';
        }

        return new Intl.RelativeTimeFormat('en', {
            style: 'narrow',
        }).format(
            (-1 * this.stats.msSinceStart) /
                (this.stats.msSinceStart < 60 * 1000 ? 1000 : 60 * 1000),
            this.stats.msSinceStart < 60 * 1000 ? 'seconds' : 'minutes'
        );
    }

    get lastStatusClass(): string {
        switch (this.stats.lastStatus) {
            case 'connected':
                return 'debug-waas__kv__last-status__connected';
            case 'error':
                return 'debug-waas__kv__last-status__error';
            case 'disconnected':
                return 'debug-waas__kv__last-status__disconnected';
            case 'idle':
                return 'debug-waas__kv__last-status__idle';
            default:
                return '';
        }
    }
}
